export { default as HomepageModel } from './model'
